var simplecms = simplecms || {}; simplecms["viewGallery"] =
webpackJsonpsimplecms__name_(["viewGallery"],{

/***/ "./js/viewGallery/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["init"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("./node_modules/preact/dist/preact.esm.js");


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @jsx h */
/* eslint-disable react/prop-types */


function extractImages(galleryDomNode) {
    var thumbNodes = galleryDomNode.querySelectorAll('.gallery__thumb');

    return {
        images: Array.prototype.map.call(thumbNodes, function (thumbNode) {
            return {
                thumbSrc: thumbNode.src,
                // TODO: srcset
                fullSrc: thumbNode.parentNode.href,
                title: thumbNode.title
            };
        }),
        id: galleryDomNode.id,
        elem: galleryDomNode
    };
}

function extractGallery(id) {
    var elem = document.getElementById(id);
    return extractImages(elem);
}

function clearDom(elem) {
    while (elem.firstChild) {
        elem.removeChild(elem.firstChild);
    }
}

var Gallery = function (_Component) {
    _inherits(Gallery, _Component);

    function Gallery(props) {
        _classCallCheck(this, Gallery);

        var _this = _possibleConstructorReturn(this, (Gallery.__proto__ || Object.getPrototypeOf(Gallery)).call(this, props));

        _this.nextImage = function (e) {
            var _this$state = _this.state,
                currentIndex = _this$state.currentIndex,
                busy = _this$state.busy;

            e.preventDefault();
            if (busy) return;
            _this.switchTo(currentIndex + 1);
        };

        _this.previousImage = function (e) {
            var _this$state2 = _this.state,
                currentIndex = _this$state2.currentIndex,
                busy = _this$state2.busy;

            e.preventDefault();
            if (busy) return;
            _this.switchTo(currentIndex - 1);
        };

        _this.state = {
            currentIndex: 0,
            busy: false
        };
        return _this;
    }

    _createClass(Gallery, [{
        key: 'startLoading',
        value: function startLoading(index) {
            var _this2 = this;

            var image = this.props.images[index];
            var img = new Image();
            img.onload = function () {
                _this2.setState({
                    currentIndex: index,
                    busy: false
                });
            };
            img.src = image.fullSrc;
        }
    }, {
        key: 'switchTo',
        value: function switchTo(index) {
            var images = this.props.images;

            index = index % images.length;
            if (index < 0) index = images.length - 1;
            this.setState({
                busy: true
            });
            this.startLoading(index);
        }
    }, {
        key: 'render',
        value: function render(_ref, _ref2) {
            var images = _ref.images;
            var currentIndex = _ref2.currentIndex,
                busy = _ref2.busy;

            var currentImage = images[currentIndex];
            var classes = ['gallery__main'];
            if (busy) {
                classes.push('gallery__main--busy');
            }
            return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { className: 'gallery' },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'div',
                    { className: classes.join(' ') },
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { className: 'gallery__main-image', src: currentImage.fullSrc }),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                        'div',
                        { className: 'gallery__overlay gallery__overlay--left', onClick: this.previousImage },
                        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('i', { className: 'fa fa-chevron-left gallery__prev' })
                    ),
                    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                        'div',
                        { className: 'gallery__overlay gallery__overlay--right', onClick: this.nextImage },
                        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('i', { className: 'fa fa-chevron-right gallery__next' })
                    )
                ),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'p',
                    { className: 'gallery__title' },
                    currentImage.title
                ),
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                    'div',
                    { className: 'gallery__thumbs' },
                    this.renderThumbs()
                )
            );
        }
    }, {
        key: 'renderThumbs',
        value: function renderThumbs() {
            var _this3 = this;

            var images = this.props.images;


            return images.map(function (image, idx) {
                return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { src: image.thumbSrc, key: idx, className: 'gallery__thumb', onClick: function onClick() {
                        return _this3.switchTo(idx);
                    } });
            });
        }
    }]);

    return Gallery;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

function init(id) {
    var gallery = extractGallery(id);
    clearDom(gallery.elem);
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["render"])(Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(Gallery, { images: gallery.images }), gallery.elem);
}

//import('preact/devtools');

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./js/viewGallery/index.js");


/***/ })

},[11]);


// WEBPACK FOOTER //
// viewGallery.entry.js